import { Box } from "@mui/material";
import React, { useState } from "react";

const extractYouTubeVideoId = (url) => {
    if (typeof url !== "string") {
        console.error("Invalid URL: URL must be a string");
        return null;
      }
    
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      
      return match ? match[1] : null;
  }

const YouTubeHoverPreview = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const videoId = extractYouTubeVideoId(props.video);
  
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=1&loop=1&playlist=${videoId}`;
  
  return (
    <Box
      sx={{
        ...props.sx
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{ 
        position: 'relative', 
        width: '100%', 
        aspectRatio: '16/9',
        cursor: 'pointer', 
        overflow: 'hidden', 
        lineHeight: 0 
      }}>
        <img
          src={thumbnailUrl}
          alt="YouTube Thumbnail"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: isHovered ? 'none' : 'block'
          }}
        />
        
        {isHovered && (
          <iframe
            src={videoUrl}
            title="YouTube Video Preview"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </Box>
  );
};

export default YouTubeHoverPreview;